if (!customElements.get("m-image-layer")) {
  class MImageLayer extends HTMLElement {
    constructor() {
      super();
      this.enableParallax = false;
    }

    connectedCallback() {
      this.enableParallax = this.dataset.enableParallax === "true";
      if (this.enableParallax) {
        this.initElements();
        MinimogTheme.Motion.inView(this, this.initAnimations.bind(this));
      }
    }

    initElements() {
      this.firstImage = this.querySelector(".m-image-with-text__image-first");
      this.secondImage = this.querySelector(".m-image-with-text__image-second");

      if (!this.firstImage || !this.secondImage) {
        console.error("MImageLayer: Required elements not found.");
        return;
      }
    }

    initAnimations() {
      this.animateElement(this.secondImage, [`translateY(30%)`, `translateX(0)`]);
      this.animateElement(this.firstImage, [`translateY(-5%)`, `translateX(0)`]);
    }

    animateElement(element, transforms) {
      MinimogTheme.Motion.scroll(
        MinimogTheme.Motion.animate(element, { transform: transforms }, { easing: "linear" }),
        {
          target: element,
          offset: ["start end", "end start"],
        }
      );
    }
  } 

  customElements.define("m-image-layer", MImageLayer);
}





  $(function () {

    $('.product-hotspot').each(function () {
      const x = parseFloat($(this).data('x'));
      if (x > 50) {
        $(this).addClass('flip-left');
      }
    });

    $('.image-hotspot-wrapper').on('click', '.hotspot-dot', function (e) {
      e.stopPropagation();

      const hotspot = $(this).closest('.product-hotspot');

      $('.product-hotspot').not(hotspot).removeClass('is-active');
      hotspot.toggleClass('is-active');
    });

    $(document).on('click', function () {
      $('.product-hotspot').removeClass('is-active');
    });

    

    setTimeout(function () {
      jQuery("#tab_8gXi8j").addClass("active");
    }, 4000);
      
  });

jQuery(function ($) {

  const $cards = $('.expanding-flex-cards');
  const $items = $('.expanding-flex-cards-item');
  const $slider = $('.efc-false-slider');
  const $fill = $('.efc-fs-fill');

  if (!$cards.length || !$slider.length) return;

  function updateProgress() {
    const scrollLeft = $cards.scrollLeft();
    const maxScroll =
      $cards[0].scrollWidth - $cards.outerWidth();

    let progress = maxScroll > 0
      ? scrollLeft / maxScroll
      : 0;

    // Clamp between 2% and 100%
    const minPercent = 2;
    const percent = Math.max(minPercent, progress * 100);

    $fill.css('width', percent + '%');

    updateActiveCard();
  }


  function updateActiveCard() {
    const scrollCenter =
      $cards.scrollLeft() + ($cards.outerWidth() / 2);

    let closestIndex = 0;
    let closestDistance = Infinity;

    $items.each(function (i) {
      const itemCenter =
        $(this).position().left +
        ($(this).outerWidth() / 2);

      const distance = Math.abs(scrollCenter - itemCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    });

    $items.removeClass('active')
      .eq(closestIndex)
      .addClass('active');
  }

  // Scroll → slider
  $cards.on('scroll', function () {
    requestAnimationFrame(updateProgress);
  });

  // Slider click → scroll
  $slider.on('click', function (e) {
    const sliderWidth = $slider.width();
    const clickX = e.offsetX;

    const ratio = clickX / sliderWidth;

    const maxScroll =
      $cards[0].scrollWidth - $cards.outerWidth();

    $cards.animate({
      scrollLeft: maxScroll * ratio
    }, 400);
  });

  // Init
  updateProgress();

});
